import React from 'react';
import { isWidthUp, makeStyles, withWidth } from '@material-ui/core';
import Drawer from "@material-ui/core/Drawer";
import Map from './livetrackmap/Map';
import CurrentPositionsMap from './livetrackmap/CurrentPositionsMap';
import CurrentLocationMap from './livetrackmap/CurrentLocationMap';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flexGrow: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('xs')]: {
     flexDirection: 'column-reverse',
    }
  },
  drawerPaper: {
    position: 'relative',
    [theme.breakpoints.up('sm')]: {
     width: 350,
    },
    [theme.breakpoints.down('xs')]: {
     height: 250,
    }
  },
  mapContainer: {
   flexGrow: 1,
  },
 }));

 const LiveTracking = (props) => {
  const queryString = props.location && props.location.search;

  const urlParams = new URLSearchParams(queryString);
  const accessToken = urlParams.get("accessToken");
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <div className={classes.mapContainer}>
          <Map>
            <CurrentLocationMap />
            <CurrentPositionsMap accessToken={accessToken} />
          </Map>
        </div>
      </div>
    </div>
  );
}

export default withWidth()(LiveTracking);
